import React from 'react';
import { toTitleCase } from 'src/components/UserRegistrationSteps/StepThree/signupHook';
import TagForm, { ITagFormData } from './TagForm';

export type ICreateTagFormData = ITagFormData;

interface Props {
  onClose: () => void;
  workspaceId: string;
  usage: string;
}

const CreateTag: React.FC<Props> = ({ onClose, workspaceId, usage }) => {
  const title = toTitleCase(usage)?.slice(0, -1);

  return (
    <TagForm
      mode="create"
      onClose={onClose}
      workspaceId={workspaceId}
      usage={usage}
      headingTitle={`Create ${title} Tag`}
      backButtonLabel={`Back to ${title} Tags`}
      submitButtonLabel="Create Tag"
      successToastTitle="New Tag Created"
    />
  );
};

export default CreateTag;
